import type { MailAccountSummary } from "@/lib/types/mail";
import { fetchMailAccountPhotoBlob } from "@/lib/api/accountPhotos";

const blobCache = new Map<string, string>();

function cacheKey(accountId: number, photoVersion: number): string {
  return `${accountId}:${photoVersion}`;
}

export function invalidateAccountPhotoCache(accountId: number): void {
  for (const key of blobCache.keys()) {
    if (key.startsWith(`${accountId}:`)) {
      const url = blobCache.get(key);
      if (url?.startsWith("blob:")) {
        URL.revokeObjectURL(url);
      }
      blobCache.delete(key);
    }
  }
}

export async function getAccountPhotoBlob(account: MailAccountSummary): Promise<string | null> {
  if (!account.photoUrl || (account.photoVersion ?? 0) <= 0) return null;

  const key = cacheKey(account.id, account.photoVersion ?? 0);
  const cached = blobCache.get(key);
  if (cached) return cached;

  const blobUrl = await fetchMailAccountPhotoBlob(account.photoUrl);
  if (blobUrl) {
    blobCache.set(key, blobUrl);
  }
  return blobUrl;
}

export function primeAccountPhotoBlob(
  accountId: number,
  photoVersion: number,
  blobUrl: string
): void {
  invalidateAccountPhotoCache(accountId);
  blobCache.set(cacheKey(accountId, photoVersion), blobUrl);
}
